import React from 'react';

/**
 * HOC that wraps TopBar to inject PrimeMenu with backendSpecs actions and selectors
 */
const TopBarPrimeMenuWrapper = (Original, system) => {
  const Wrapper = (props) => {
    // Access actions and selectors from system
    const backendSpecsActions = system?.backendSpecsActions || {};
    const backendSpecsSelectors = system?.backendSpecsSelectors || {};
    const editorSelectors = system?.editorSelectors || {};
    
    // Get pagoAuth2 from props (from TopBarWrapper) or system
    const pagoAuth2Selectors = props.pagoAuth2Selectors || system?.pagoAuth2Selectors || {};
    const pagoAuth2Actions = props.pagoAuth2Actions || system?.pagoAuth2Actions || {};

    return (
      <Original
        {...props}
        backendSpecsActions={backendSpecsActions}
        backendSpecsSelectors={backendSpecsSelectors}
        pagoAuth2Selectors={pagoAuth2Selectors}
        pagoAuth2Actions={pagoAuth2Actions}
        editorSelectors={editorSelectors}
      />
    );
  };

  return Wrapper;
};

export default TopBarPrimeMenuWrapper;

